import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private httpClient: HttpClient) { }
        baseUrl = environment.baseUrl;
        xApiKey = environment.xApiKey;

  getMaterialGroup(materialGroupId: any, materialGroupName: any, materialGroup : any, pageNo: any, pageSize: any){
    return this.httpClient.get(this.baseUrl+`/get_material_group_list?materialGroupId=${materialGroupId}&materialGroupName=${materialGroupName}&materialGroup=${materialGroup}&pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getUserFunctionDropdown(){
    return this.httpClient.get(this.baseUrl+`/get_user_function_dropdown`);
  }

  editUserProfile(emailAddress: any, body: any){
    return this.httpClient.post(this.baseUrl + `/edit_user_profile?emailAddress=${emailAddress}`, body);
  }
}
